import React, { useEffect, useState } from 'react';

/** Route element for /terms, /privacy, /cookies, /refund. docKey = terms|privacy|cookies|refund.
 *  The backend returns pre-escaped HTML generated from the Markdown documents. */
export default function LegalPage({ docKey, apiBase = process.env.REACT_APP_BACKEND_URL || '' }) {
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    fetch(`${apiBase}/api/legal/docs/${docKey}`).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setDoc).catch(() => setErr('Could not load this document. Please try again.'));
  }, [docKey, apiBase]);
  return (
    <main className="legal-page" data-testid={`legal-page-${docKey}`}
      style={{ maxWidth: 820, margin: '0 auto', padding: '32px 20px', lineHeight: 1.6 }}>
      {err && <p>{err}</p>}
      {!doc && !err && <p>Loading…</p>}
      {/* eslint-disable-next-line react/no-danger */}
      {doc && <article dangerouslySetInnerHTML={{ __html: doc.html }} />}
    </main>
  );
}
